import { PRIVATE_SIGNIN_REFRESH_STUDENT_SESSION } from 'global/private-routes.constants';
import { PRIVATE_SIGNIN_REFRESH_SESSION } from 'global/private-routes.constants';

export const isOnSignInRefreshSessionPage = () => {
  return (
    window.location.pathname.includes(PRIVATE_SIGNIN_REFRESH_SESSION) ||
    window.location.pathname.includes(PRIVATE_SIGNIN_REFRESH_STUDENT_SESSION)
  );
};
